/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_more_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New tools are added regularly, and every one ships with the same on-page explainer, worked examples and FAQ.`)
};

const es_about_more_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se añaden nuevas herramientas con regularidad, y cada una incluye la misma explicación en la página, ejemplos resueltos y preguntas frecuentes.`)
};

const de_about_more_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regelmäßig kommen neue Werkzeuge hinzu, und jedes wird mit derselben Erklärung auf der Seite, durchgerechneten Beispielen und FAQ ausgeliefert.`)
};

const nl_about_more_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er worden regelmatig nieuwe tools toegevoegd, en elke tool wordt geleverd met dezelfde uitleg op de pagina, uitgewerkte voorbeelden en veelgestelde vragen.`)
};

const fr_about_more_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De nouveaux outils sont ajoutés régulièrement, et chacun est livré avec la même explication sur la page, des exemples résolus et une FAQ.`)
};

const it_about_more_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovi strumenti vengono aggiunti regolarmente, e ognuno viene rilasciato con la stessa spiegazione in pagina, esempi svolti e domande frequenti.`)
};

const pt_br2_about_more_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novas ferramentas são adicionadas regularmente, e cada uma vem com a mesma explicação na página, exemplos resolvidos e perguntas frequentes.`)
};

const pt_about_more_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São adicionadas novas ferramentas regularmente, e cada uma é lançada com a mesma explicação na página, exemplos resolvidos e perguntas frequentes.`)
};

const ja_about_more_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいツールは定期的に追加され、それぞれ同じページ内解説、解いた例、FAQを備えています。`)
};

const zh_about_more_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新工具会持续定期上线，每一款都配有相同的页面说明、示例演算和常见问题解答。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_more_tools = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_more_tools(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_more_tools", locale)
	if (locale === "en") return en_about_more_tools(inputs)
	if (locale === "es") return es_about_more_tools(inputs)
	if (locale === "de") return de_about_more_tools(inputs)
	if (locale === "nl") return nl_about_more_tools(inputs)
	if (locale === "fr") return fr_about_more_tools(inputs)
	if (locale === "it") return it_about_more_tools(inputs)
	if (locale === "pt-BR") return pt_br2_about_more_tools(inputs)
	if (locale === "pt") return pt_about_more_tools(inputs)
	if (locale === "ja") return ja_about_more_tools(inputs)
	return zh_about_more_tools(inputs)
};